import { FC, memo } from 'react';

import AccountsPresenter from './AccountsPresenter';

const Accounts: FC = memo(() => (
  <AccountsPresenter />
));

export default Accounts;
